export const actionStyles =
  'border disabled:cursor-not-allowed inline-flex items-center space-x-2 rounded-lg px-2 py-2 hover:bg-gray-50 font-medium text-sm focus:ring-1 focus:ring-opacity-90'
